import { ErrorOutlineIcon, Flex, Text, Tooltip } from '@shared/components';

interface SubtopicErrorTooltipProps {
  error: boolean;
}

export default function SubtopicErrorTooltip(props: Readonly<SubtopicErrorTooltipProps>) {
  const { error: isError = false } = props;

  if (!isError) {
    return null;
  }

  return (
    <Tooltip
      title={
        <Flex sx={{ alignItems: 'center' }}>
          <ErrorOutlineIcon
            sx={{ mr: 1, color: (theme) => theme.palette.error.main, fontSize: '16px' }}
          />
          <Text
            sx={{ color: (theme) => theme.palette.error.darker }}
            variant='body2'
            fontWeight={600}
          >
            กรุณาเพิ่มหัวข้อย่อย
          </Text>
        </Flex>
      }
      placement='top'
      arrow
      sx={{
        width: 'fit-content',
        color: (theme) => theme.palette.error.main,
      }}
      slotProps={{
        tooltip: {
          sx: (theme) => ({
            p: theme.spacing(2, 3),
            border: '1px solid',
            borderColor: theme.palette.error.main,
            bgcolor: theme.palette.error.lighter,
            '& .MuiTooltip-arrow': {
              '&::before': {
                border: '1px solid',
                borderColor: theme.palette.error.main,
                backgroundColor: theme.palette.error.lighter,
                boxSizing: 'border-box',
              },
            },
          }),
        },
      }}
    >
      <ErrorOutlineIcon color='error' />
    </Tooltip>
  );
}
